import React from "react";

import styled from "styled-components";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as DriverServiceMigrationActions from "../../../store/actions/DriverServiceMigration";
import BulkUploadFile from "../../BulkUploadFile";

const instructions = [
  "Please provide data as per the format in the sample file.",
  "Max upload limit is 1000.",
];

const FileUploadModal = ({ getUploadUrl }) => {
  return (
    <BlinkitToZomatoMigration>
      <BulkUploadFile
        instructions={instructions}
        btnDataTestID="BlinkitToZomatoActionsUpload"
        uploadUrl="/driver-service-migration/blinkit-to-zomato/bulk-upload/ack"
        sampleURL="/sample/bulk_upload_blinkit_to_zomato_migration.csv"
        id="bulkUploadBlinkitToZomatoMigrationModal"
        sendExtraAck={true}
        keyName="callback_key"
        heading="Bulk Blinkit to Zomato Service Migration"
        getUploadUrl={getUploadUrl}
      />
    </BlinkitToZomatoMigration>
  );
};

const BlinkitToZomatoMigration = styled.section``;

function mapDispatchToProps(dispatch) {
  return {
    getUploadUrl: bindActionCreators(
      DriverServiceMigrationActions.getBlinkitToZomatoMigrationUploadUrl,
      dispatch
    ),
  };
}

export default connect(null, mapDispatchToProps)(FileUploadModal);
